<template>
  <CustomerSearch
    v-if="customer === null"
    @update="$emit('update:customer', $event)"
    @create="popup = true"
  />
  <CustomerCard
    v-else
    :customer="customer"
    :allow-edit="allowEdit"
    @change="$emit('update:customer', null)"
    @edit="popup = true"
  />
  <p v-if="error" class="text-error mt-1 text-xs">
    {{ error }}
  </p>
  <BaseModal :show="popup" size="md" panel="white" @close="popup = false">
    <template #title>Customer</template>
    <CustomerPopup
      :customer="customer"
      @cancel="popup = false"
      @update="$emit('update:customer', $event)"
    />
  </BaseModal>
</template>

<script setup lang="ts">
import { useFormContext } from "@/composables/useFormContext";
import BaseModal from "@/modals/BaseModal.vue";
import { type Customer } from "@/services/bookings/customers.js";

const props = defineProps<{
  customer: Customer | null;
  name: string;
  allowEdit?: boolean;
}>();
defineEmits(["update:customer"]);

const popup = ref(false);
const error = ref<string | null>(null);

const formContext = useFormContext();
formContext.registerField(props.name, {
  validate() {
    if (props.customer === null) {
      error.value = "Customer required";
      return false;
    }
    return true;
  },
  resetValidation() {
    error.value = null;
  },
  setError(message: string) {
    error.value = message;
  },
});

onBeforeUnmount(() => formContext.unregisterField(props.name));
</script>
